import cn from 'classnames';
import styles from './UpdatesDot.module.css';

type Props = {
  className?: string;
};

/**
 * {@link UpdatesDot} marks that something shipped since the user last looked. It is decorative:
 * wherever it is placed, the unread state also has to reach assistive tech as text.
 */
export function UpdatesDot({ className }: Props) {
  return <span className={cn(styles.UpdatesDot, className)} data-testid="updates-dot" aria-hidden={true} />;
}
